import fetch from './fetch'

class BillApi {
	public addBill(form: any) {
		return fetch({
			url: 'injury/order/addInvoice',
			method: 'post',
			data: form,
			timeout: 60 * 1000,
		})
	}

	public getList(form: any) {
		return fetch({
			url: 'injury/tasklist/invoice/list',
			method: 'post',
			data: form,
		})
	}

	public getDetail(orderId: any) {
		return fetch({
			url: 'injury/order/invoiceDetail',
			params: {
				orderId,
			},
		})
	}
}

export default new BillApi()
